import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { API_ENDPOINTS, LIST_STATES, SM_QUEUE_SERVER } from "../constants/constants";
import { getDispositionList, messageApiRequest, saveDispositionToSvr, triggerNotifications } from "../Helpers/helperMessages";
import { dispositionsModel } from "../mappers/models.mapper";
import { getSvrCallbacks } from "./reprogramCall";

const date = new Date();

export const saveSvrDisposition = (svrResource, dispositionID, subdispositionID) => {
    svrResource.sharedData.setIsRated(true);
    const dispositionBehavior = svrResource.sharedData.getGeneralPermissions()[99];
    const dateNow = new Date();
    const disposition = parseInt(dispositionID), subdisposition = parseInt(subdispositionID);
    let timeDifference = dateNow.getTime() - date.getTime();
    const exitAssistedMode = svrResource.sharedData.getExitAssistedMode(disposition);
    if(timeDifference > 1000){
        const messageParameters = saveDispositionToSvr(disposition, subdisposition, exitAssistedMode);
        const message = messageApiRequest(API_ENDPOINTS.SAVE_DISPOSITION, messageParameters);
        svrResource.sendToRabbit(SM_QUEUE_SERVER, message);
        if(svrResource.sharedData.currentState === LIST_STATES.DIALOG){
            svrResource.sharedCallOutData.saveDispositionInDialog = true;
        }
        if(svrResource.sharedData.currentState === LIST_STATES.WRAPUP && svrResource.sharedData.currentState !== LIST_STATES.ASSISTED && svrResource.sharedCallOutData.exitDispositionsMode === false){
            if(dispositionBehavior === '2'){
                if(svrResource.sharedCallOutData.saveDispositionInDialog){
                    svrResource.setReady();
                }
            } else {
                svrResource.setReady();
            }
        }
    }
}

export const requestDispositions = (svrResource, userID, requestTimeout, action) => { 
    const objResponse = svrResource.apiCont.getObjectResponse();
    const typeCall = svrResource.sharedCallOutData.callType || svrResource.callType;
    const message = getDispositionList(svrResource.callOutID, svrResource.camId, typeCall, userID);
    svrResource.apiCont.dispositionList(message, objResponse, requestTimeout);
    
    objResponse.onError = (messageError) => handleDispositionError(svrResource, action, messageError);
    objResponse.onCatch = (messageError) => handleDispositionCatch(svrResource, action, messageError);
    objResponse.onSuccess = (response) => handleDispositionSuccess(svrResource, userID, requestTimeout, action, response);
};

const handleDispositionError = (svrResource, action, messageError) => { 
    console.warn("[AgentSDK] [ResponseFromServer] [Error]: Error consulting DB → " + messageError); 
    const errorHandlers = { 
        getDispositions: () => { 
            svrResource.errorEvents.errorReceivedDispositions([]); 
            triggerNotifications(svrResource, MESSAGE_CODE.DISPOSITIONS[11104], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK); 
        }, 
        getDispositionsAndNumbers: () => { 
            svrResource.errorEvents.errorReceivedDispositionsAndNumbers([]); 
            triggerNotifications(svrResource, MESSAGE_CODE.DISPOSITIONS[11104], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK); 
        }, 
        getPhoneNumbers: () => { 
            svrResource.errorEvents.errorReceivedGetPhoneNumbers([]); 
        } 
    }; 
    errorHandlers[action]?.(); 
};

const handleDispositionCatch = (svrResource, action, messageError) => { 
    console.warn("[AgentSDK] [ResponseFromServer] [Error]: Error processing data → " + messageError); 
    const catchHandlers = { 
        getDispositions: () => svrResource.errorEvents.errorReceivedDispositions([]), 
        getDispositionsAndNumbers: () => svrResource.errorEvents.errorReceivedDispositionsAndNumbers([]), 
        getPhoneNumbers: () => svrResource.errorEvents.errorReceivedGetPhoneNumbers([]) 
    }; 
    catchHandlers[action]?.(); 
};

const handleDispositionSuccess = (svrResource, userID, requestTimeout, action, objResponse) => { 
    const validateDispositions = Object.keys(objResponse.Dispositions).length === 0; 
    const dispositionModel = dispositionsModel(objResponse.Dispositions); 
    const arrayNums = Object.keys(objResponse.Numbers).map(i => objResponse.Numbers[i]); 
    
    const successHandlers = { 
        getDispositions: () => { 
            if (!validateDispositions) {
                console.log("[AgentSDK] [getDispositions]: Dispositions List OK.");
                svrResource.sharedData.setExitAssistedMode(objResponse.Dispositions);
                svrResource.svrEvents.onReceivedDispositions(dispositionModel);
                getSvrCallbacks(svrResource, userID, requestTimeout, 0);
                triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
            } else {
                svrResource.sharedCallOutData.exitDispositionsMode = true; svrResource.errorEvents.errorReceivedDispositions([]);
                console.warn("[AgentSDK] [Info]: No dispositions assigned to campaign, [ exitDispositionMode ] enabled.");
                triggerNotifications(svrResource, MESSAGE_CODE.DISPOSITIONS[11105], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
            }
        },
        getDispositionsAndNumbers: () => { 
            console.log("[AgentSDK] [getDispositions]: Dispositions and Numbers List OK.");
            handleDispositionsAndNumbers(svrResource, validateDispositions, objResponse, arrayNums);
        }, 
        exitDispositionMode: () => { 
            const lengthDispositions = Object.keys(dispositionModel).length === 0;
            const isValidState = svrResource.sharedData.currentState == 'Wrapup' && svrResource.sharedData.currentState !== 'Assisted';
            if (isValidState && lengthDispositions && svrResource.sharedCallOutData.exitDispositionsMode == true) {
                console.info("[AgentSDK] [exitDispositionMode]: Exit mode [Wrapup].");
                svrResource.setReady();
            } else {
                triggerNotifications(svrResource, MESSAGE_CODE.DISPOSITIONS[11106], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
            }
        },
        getPhoneNumbers: () => {
            console.log("[AgentSDK] [getDispositions]: Phone Numbers List OK.");
            handlePhoneNumbers(svrResource, arrayNums);
        }
    };
    successHandlers[action]?.();
};

const handleDispositionsAndNumbers = (svrResource, validateDispositions, objResponse, arrayNums) => {
    let numbersList = {};
    if (arrayNums.length === 0) {
        numbersList = { "phoneNumbers": [{ id: 1, number: svrResource.sharedCallOutData.phone, img: "reprogramacion1" }] };
        svrResource.sharedCallOutData.selectedPhoneItem = { id: 1, number: svrResource.sharedCallOutData.phone };
    } else {
        const imagesNumber = { "1": "reprogramacion1", "2": "reprogramacion2", "3": "reprogramacion3", "4": "reprogramacion4", "5": "reprogramacion5" };
        arrayNums = arrayNums.map(item => ({ img: imagesNumber[item.Graphic], number: item.Phone, id: item.Graphic }));
        arrayNums = arrayNums.filter(item => item.number !== "");
        numbersList = { "phoneNumbers": arrayNums };
        svrResource.sharedCallOutData.selectedPhoneItem = arrayNums[0];
    }

    if (!validateDispositions) {
        svrResource.sharedData.setExitAssistedMode(objResponse.Dispositions);
        const dispositionModel = [{ "dispositions": dispositionsModel(objResponse.Dispositions) }];
        svrResource.svrEvents.onReceivedDispositionsAndNumbers(dispositionModel.concat(numbersList));
        triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
    } else {
        svrResource.sharedCallOutData.exitDispositionsMode = true;
        svrResource.errorEvents.errorReceivedDispositionsAndNumbers([]);
        console.warn("[AgentSDK] [Info]: No dispositions assigned to campaign, [ exitDispositionMode ] enabled.");
        triggerNotifications(svrResource, MESSAGE_CODE.DISPOSITIONS[11105], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
};

const handlePhoneNumbers = (svrResource, arrayNums) => {
    let onlyNumbersList = {};
    if (arrayNums.length === 0) {
        onlyNumbersList = [{ id: 1, number: svrResource.sharedCallOutData.phone }];
        svrResource.sharedCallOutData.selectedPhoneItem = { id: 1, number: svrResource.sharedCallOutData.phone };
    } else {
        onlyNumbersList = Object.keys(arrayNums).map(i => ({ number: arrayNums[i].Phone, id: parseInt(i) + 1 }));
        onlyNumbersList = onlyNumbersList.filter(item => item.number !== "");
        svrResource.sharedCallOutData.selectedPhoneItem = onlyNumbersList[0];
    }
    svrResource.svrEvents.onReceivedGetPhoneNumbers(onlyNumbersList);
    triggerNotifications(svrResource, MESSAGE_CODE.CONNECTION_ALERTS[200], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
};